export var FlagIconThemes = {
    blue: {
        light: '#00D2E9',
        medium: '#006B9C',
        dark: '#171FE3',
    },
    green: {
        light: '#89ED01',
        medium: '#52AA0D',
        dark: '#117E20',
    },
    orange: {
        light: '#FFDBB3',
        medium: '#d19c5e',
        dark: '#FFAB2D',
    },
    red: {
        light: '#FF3364',
        medium: '#cd0033',
        dark: '#CC0033',
    },
    purple: {
        light: '#B37FF5',
        medium: '#812EEB',
        dark: '#9B57F2',
    },
};
